
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoWnYp8TRC7_45ZjDqWq_Zsz9YSrJ80PGiT8CQxwlHwsJ_MMeta } from "/var/www/2025-05-06_07_36/pages/edo.vue?macro=true";
import { default as helpdzYdqrocr_45LdardKtJHbTCBTEgTmqt1FqeBHQ4JO57YMeta } from "/var/www/2025-05-06_07_36/pages/help.vue?macro=true";
import { default as cargoJyIbNIferV6uR5aocmdpcDOE1a0Q_45lVtfBi0j9RJlXcMeta } from "/var/www/2025-05-06_07_36/pages/cargo.vue?macro=true";
import { default as chinaWCNy4pKeli77ENAmG0FNxDSRB6na7PbFDzyHW3uQoY0Meta } from "/var/www/2025-05-06_07_36/pages/china.vue?macro=true";
import { default as index3_kRs6hKJ4H8UlnoTh7waGWV7q2vYBkU84NY3XJSWUwMeta } from "/var/www/2025-05-06_07_36/pages/index.vue?macro=true";
import { default as _91slug_93jWD_45tS4_SJZPazzqth3Z7dMNyLZ__45AR9uwcvjkHfkugMeta } from "/var/www/2025-05-06_07_36/pages/[slug].vue?macro=true";
import { default as belarus_btIBN2Zy8_45t4qrSWef6pgYCSL8ZZyRQKVeZbsJo7O0Meta } from "/var/www/2025-05-06_07_36/pages/belarus.vue?macro=true";
import { default as bonusesyQGt_PKg4765EWm_45CVPNGXnMrxkAACO3TTs_4536fxpS0Meta } from "/var/www/2025-05-06_07_36/pages/bonuses.vue?macro=true";
import { default as apiJOfYKwl7NOoSGxIEYydtBX8yaUgi6qggtPB35ZPYbVYMeta } from "/var/www/2025-05-06_07_36/pages/dev/api.vue?macro=true";
import { default as cmsM68R7Cy5EMHwcC00UYvF2l_7kwog9y_45WsGYayk0C8aEMeta } from "/var/www/2025-05-06_07_36/pages/dev/cms.vue?macro=true";
import { default as konkursBHKUjnq_WB8ACnMe7UHPbq7ibBApHqr53a_vmU53FF8Meta } from "/var/www/2025-05-06_07_36/pages/konkurs.vue?macro=true";
import { default as successpRtbo60GPPrbYMHFiKpKzSkmIlotQzr2GdM5jPEQ3AEMeta } from "/var/www/2025-05-06_07_36/pages/success.vue?macro=true";
import { default as tariffs8PYp1lkdhzRGUjE_453knyh_zqPBA1mUXsw0p8v8Rd6igMeta } from "/var/www/2025-05-06_07_36/pages/tariffs.vue?macro=true";
import { default as vacancy_45zYt1gCGj4eY7BxQl_45sQ704K_450f64gCgzQ2LG1U7wO8Meta } from "/var/www/2025-05-06_07_36/pages/vacancy.vue?macro=true";
import { default as contactsrjGe0E6sjCxYr5_45ePlx2vRoYWKEvm_bVGcLVx_45AGGAAMeta } from "/var/www/2025-05-06_07_36/pages/contacts.vue?macro=true";
import { default as giveawayXx79_45jGoIhMyEYAx_45AyFENQj_Qrle8gmBH5upXzdowYMeta } from "/var/www/2025-05-06_07_36/pages/giveaway.vue?macro=true";
import { default as guide_45lkJnXcqlZjs_y8mEa2O2eu9B6rUiQoW_453j0kN5aoQrtyMMeta } from "/var/www/2025-05-06_07_36/pages/guide-lk.vue?macro=true";
import { default as servicesLJOICDbjTVlA8lBS50bFfUWK56NMqa_PFXGObNsxWiMMeta } from "/var/www/2025-05-06_07_36/pages/services.vue?macro=true";
import { default as telegramfuJ7VjVt_45G1oFhc2IOz_45ZqBKiht5BefDD0EMWchlHf0Meta } from "/var/www/2025-05-06_07_36/pages/telegram.vue?macro=true";
import { default as documentsDaQpOgBIg6LJVyxmOdPKS_UtMqwBr6Jx1hEdelSJZD8Meta } from "/var/www/2025-05-06_07_36/pages/documents.vue?macro=true";
import { default as franchiseh7Cl6ArHXJDiYT6VrkYfZXNzwTIyIe9h4DaOcHSbAbIMeta } from "/var/www/2025-05-06_07_36/pages/franchise.vue?macro=true";
import { default as insuranceRXvdbuiOEc6QhgkI1_45EOn7iyuR9IvYH9_0TuQmPRTu4Meta } from "/var/www/2025-05-06_07_36/pages/insurance.vue?macro=true";
import { default as kirghizia6yAuXQ2OdblbQN3xlClmiwhvMhvg5RkR4o5llYsIvoQMeta } from "/var/www/2025-05-06_07_36/pages/kirghizia.vue?macro=true";
import { default as mapScheme1FCvRJcdpPl1Hp7kWuyGcGlSTLcOSOAEO2hZF5S5TcwMeta } from "/var/www/2025-05-06_07_36/pages/mapScheme.vue?macro=true";
import { default as _91id_93BNFh2j8i9LH3gnKm6us783A09JCt6jKNx6clB65vB2QMeta } from "/var/www/2025-05-06_07_36/pages/news/[id].vue?macro=true";
import { default as return_45sdxOj_AvEEDLrzWvhEA7nblA_owhMRSmC3ppKHyMy5Vf8Meta } from "/var/www/2025-05-06_07_36/pages/return-sd.vue?macro=true";
import { default as smsClientd_JrA5UenZ9e4uVZ7PO4liircovqwyYHIBXeEU5_45E_AMeta } from "/var/www/2025-05-06_07_36/pages/smsClient.vue?macro=true";
import { default as terminalsQOLxIEKhe5Q_5C0i3Aunz7wvPjryx0hM0VebeLQHaWQMeta } from "/var/www/2025-05-06_07_36/pages/terminals.vue?macro=true";
import { default as iframezPUpFV_45acUUAFj13MXGtqA2H2WSFC7UjlQgHyqQlcp0Meta } from "/var/www/2025-05-06_07_36/pages/dev/iframe.vue?macro=true";
import { default as directionsX6n2rZveZ2q0xyGVkHPmbKi08bRiNoNqse3dNnY4aAIMeta } from "/var/www/2025-05-06_07_36/pages/directions.vue?macro=true";
import { default as kazakhstani7nE62vbT0Etxwr9TLMHR_0_45eAx7k0LnK9jF5UEihRUMeta } from "/var/www/2025-05-06_07_36/pages/kazakhstan.vue?macro=true";
import { default as indexYu3Dqwy7AFsNod7DiWwzh5HMuNX110Kw28JkMTjBo2oMeta } from "/var/www/2025-05-06_07_36/pages/news/index.vue?macro=true";
import { default as svgtbPn3fgTd4w7XYjZd_45v71cmrv0DMV7U9u_BS_lQJy00Meta } from "/var/www/2025-05-06_07_36/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failAgdaGZGwAn4alTtrW_45h4YPKr3Jg_45gdBk9jctr_45cl7t8Meta } from "/var/www/2025-05-06_07_36/pages/vzpay-fail.vue?macro=true";
import { default as constructorZMJtkxXqWlR9_NyKtiXTeLYLDJxUtWLVk0zAbkqgM6YMeta } from "/var/www/2025-05-06_07_36/pages/constructor.vue?macro=true";
import { default as indexvVLVgW_aW8I_upHgOPvo0n4Qz2bFBIirebHjKr5UA54Meta } from "/var/www/2025-05-06_07_36/pages/gifts/index.vue?macro=true";
import { default as informationmh122lA6syBMOfT5z7AgKXa_Uc63pfzmoMVxC2D0CQIMeta } from "/var/www/2025-05-06_07_36/pages/information.vue?macro=true";
import { default as lightbnKdtZMJxZNhFDg9HqgMA1oVELQF9BCHPzEfSN2157AMeta } from "/var/www/2025-05-06_07_36/pages/order/light.vue?macro=true";
import { default as claim_45filingIhHAQDo3ASYQyC_45z3rbuEjlRAI69M6Xmq74TNWjEGzYMeta } from "/var/www/2025-05-06_07_36/pages/claim-filing.vue?macro=true";
import { default as _91type_93aOIikxDtXepULXBhQhDgs2rjgvFSEKvEb0T5BVnIlmQMeta } from "/var/www/2025-05-06_07_36/pages/gifts/[type].vue?macro=true";
import { default as marketplacesGI3z_dA4qP_45qANdd54McNzuK4YcjIJHANV5Mb5lPnu8Meta } from "/var/www/2025-05-06_07_36/pages/marketplaces.vue?macro=true";
import { default as networkshopsa5yN_45orkmyX3nSijKMeZLZCRjdKwYGs9WvC95jWAUGYMeta } from "/var/www/2025-05-06_07_36/pages/networkshops.vue?macro=true";
import { default as online_45store0c9hmZniaaJUezEWqnVu_LMnphCmOCmBg8fXOC0RtHUMeta } from "/var/www/2025-05-06_07_36/pages/online-store.vue?macro=true";
import { default as managecOqza6L7K_45TdX9qavI39yftD3uMsuZoYGt8V4Qm51nIMeta } from "/var/www/2025-05-06_07_36/pages/order/manage.vue?macro=true";
import { default as registration8IOgBBYKS7l3ntUdlyjaZktVUarxzbBI4L2UnjLo8jYMeta } from "/var/www/2025-05-06_07_36/pages/registration.vue?macro=true";
import { default as run_45scheduleQFq_45tP088_HR_45Gl0s9a8C_45wdVaoB4FNyk0iK88fKUHoMeta } from "/var/www/2025-05-06_07_36/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyrqrEkzbTmnqn3QlnViDx_45D1wJSvatNQbRxFGk_1tsd0Meta } from "/var/www/2025-05-06_07_36/pages/safe-custody.vue?macro=true";
import { default as image3Fkwpb78TM7J2LgzU7rLm6mZoV55_45OWY1PwFA4pljbcMeta } from "/var/www/2025-05-06_07_36/pages/ui-kit/image.vue?macro=true";
import { default as index2CiO4oJb4d5KroPShDwnYj8VTlbMr9jt4t_T2f_45V8bYMeta } from "/var/www/2025-05-06_07_36/pages/ui-kit/index.vue?macro=true";
import { default as bagNjx_45LBqjxI5HN_45Do9gteSznr8e6xdkDlg1u69oD0xwYMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/bag.vue?macro=true";
import { default as boxvo1s59HCwHfJWwzdra8yOBwghxZXmYv3Fx_45_uizSs3cMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingyizg8ibAdO5uuwMk6KVi_45l6QzhGCIT8CZGV9FDj1J3AMeta } from "/var/www/2025-05-06_07_36/pages/cargo-loading.vue?macro=true";
import { default as happybirthday3supBCJBOfxfdVRn4gdUYnRsyBxXWdJjwUaNHCt3DpYMeta } from "/var/www/2025-05-06_07_36/pages/happybirthday.vue?macro=true";
import { default as manageaz6D9blJhAbAd0A4O6rPkjeI9soWZsy4MBitqItMiHcMeta } from "/var/www/2025-05-06_07_36/pages/iframe/manage.vue?macro=true";
import { default as authZYyB8Ch_45_UosQLmHN9wwuo6g4gDjE332qdvD6fjltrYMeta } from "/var/www/2025-05-06_07_36/pages/personal/auth.vue?macro=true";
import { default as publicuFSU1cSP3QG1eWikkbJ_q_452lOccMdqaPSuZKWhMD9E8Meta } from "/var/www/2025-05-06_07_36/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerHr4WEIxQoYN2VJlyDkadjNy3M_45kSOkx_g7Dq01iHbO8Meta } from "/var/www/2025-05-06_07_36/pages/already-answer.vue?macro=true";
import { default as tariffsu6mgveuUc_A2N_45gn7YypnfZTxLUS2WZ2c4Ir_45_45prMzUMeta } from "/var/www/2025-05-06_07_36/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_938P6VL3VajBwYL81fDKzlFso2B6NDysfuvN6Pays_5FsMeta } from "/var/www/2025-05-06_07_36/pages/order/pay/[id].vue?macro=true";
import { default as index3wLWBKwFRdCKGCcoKf4PS7I_45Rak7XW_45TsUkKAKWRK_45YMeta } from "/var/www/2025-05-06_07_36/pages/personal/index.vue?macro=true";
import { default as privacy_45policy45c11t5tcxZ95fHZ2f9AxOXh1t7IjQ95jDb2xtmQcu0Meta } from "/var/www/2025-05-06_07_36/pages/privacy-policy.vue?macro=true";
import { default as _91hash_930NjF6gD6xtAzUNfyQ5gLW5_Hu3yRg9s9Tx_45mVQJ_45zfgMeta } from "/var/www/2025-05-06_07_36/pages/welcome/[hash].vue?macro=true";
import { default as index8_f421EiQhL0wfG_450XUvTclphtcYjDCNvupbBpLHSykMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russianSB03EK4WvyrgiLY72FoMP3WJhI7XcYSe_45ApRTj23fIMeta } from "/var/www/2025-05-06_07_36/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsj1yQQlq3xvIviYSfyupVIM1kOevlNSDZ66opCmDeJ8cMeta } from "/var/www/2025-05-06_07_36/pages/payment-methods.vue?macro=true";
import { default as qr_45infoh1ayBRPB4t74DnYeUG4_45C8M15_45DvcwIAwAk8KRjwNzUMeta } from "/var/www/2025-05-06_07_36/pages/payment/qr-info.vue?macro=true";
import { default as successTi4jpXZlE_TiGLK0WqjjVc0sNOKTy0yleYLC1JkA4_45wMeta } from "/var/www/2025-05-06_07_36/pages/payment/success.vue?macro=true";
import { default as importSNpKJKWe7322wArEKRqXwYNlU_45uGoZrEKPcUSQUCHwUMeta } from "/var/www/2025-05-06_07_36/pages/personal/import.vue?macro=true";
import { default as logoutIsPT4Zt5nTkvRNTCzZjCH0KTS97IqNm23KD9x7dG5GsMeta } from "/var/www/2025-05-06_07_36/pages/personal/logout.vue?macro=true";
import { default as address_45delivery49Nf_SmVBJxZkRFiBQIUAOIcaSfuuTE1fPtDRa_45_NrAMeta } from "/var/www/2025-05-06_07_36/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45delivery1fdTxhPfJs0jAEASRzRIhtZkVMThqJbrrct8lC_45_4CkMeta } from "/var/www/2025-05-06_07_36/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024cN5KLKUff4izFHDj4no3rWlcQlCNGeRYPOZOvwquVl8Meta } from "/var/www/2025-05-06_07_36/pages/happynewyear2024.vue?macro=true";
import { default as ozoncn7_YnSuN_457LPMWndbwxEhxKu6vuIevfst3jqBwqZWEMeta } from "/var/www/2025-05-06_07_36/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failQ0QtJWB6uHsWkJAUwTAzfCsUZXXbt0asFt2QkpToL5wMeta } from "/var/www/2025-05-06_07_36/pages/payment/pay-fail.vue?macro=true";
import { default as accountg2sIuyb7HF8bEUmUQOBhPfgsNtsbmrH_Y_6wq_DUN6kMeta } from "/var/www/2025-05-06_07_36/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsqhQQN4huVuuseClKq8FFEDy9YhLOE9NTbFQf8wYFAl8Meta } from "/var/www/2025-05-06_07_36/pages/prohibited-goods.vue?macro=true";
import { default as directionY_ZsTNWOONk3iZCX82r2bPSujoMe7B1WWESH93qTrF4Meta } from "/var/www/2025-05-06_07_36/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupRbXZ1eHUmyfRXc8In4C8dMBpGtchTOiCi532zkQ5GtAMeta } from "/var/www/2025-05-06_07_36/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargorle4DRxY2YW2xSOXRCULX2w0plrNvrBPNPyXrZEerkQMeta } from "/var/www/2025-05-06_07_36/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorbpjHxjmLcSE4RInMBhTd_46Q4nvWvPPoI67qmUkf3gcMeta } from "/var/www/2025-05-06_07_36/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonuseselFzKAZDVTzx_FmqVX_45kRyD6ONocej_45TkHCLrluHIucMeta } from "/var/www/2025-05-06_07_36/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93ooVE9FjLqJ3nb3YPrET5bHAycm_3G8e_Fdism6Fs2IgMeta } from "/var/www/2025-05-06_07_36/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45info4Ha17bb8l3iFEOwiGG5x2R_45m5ySMBCP21jLGjhxsSlYMeta } from "/var/www/2025-05-06_07_36/pages/payment/card-info.vue?macro=true";
import { default as discountAW8pg_SDINfRU_45SfyOBUrx8jLFJ5lZDL2scvvdxS9MoMeta } from "/var/www/2025-05-06_07_36/pages/personal/discount.vue?macro=true";
import { default as hard_45boxPlBWrlebRZKTxKFmBxvULOeTo4bv_45Z9o9IHBBIfkfOYMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receipt_45pIFpMux8pyM9y68b1HNu0nIB_fOIbIzw7lMFUzzTKIMeta } from "/var/www/2025-05-06_07_36/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917yj1wManieOVTEHqe5XgAlSx8TIBC0VP_RxdfVymf5bQMeta } from "/var/www/2025-05-06_07_36/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationgvi7c0QYOMDYHEfOtxMkY8hF6_shLwsZ1Rfvhi_V148Meta } from "/var/www/2025-05-06_07_36/pages/mobile-application.vue?macro=true";
import { default as indexiIyzLNCSjRMczh_45sN7PgdVMrZ209nh_fyysTsyHAIvMMeta } from "/var/www/2025-05-06_07_36/pages/order/create/index.vue?macro=true";
import { default as boatzAG7IJYVbgyIARI2ZNyy9ICEAiaeUIlFoyc8VAvTOyUMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/boat.vue?macro=true";
import { default as sofa0Q4eRuqIxbDVvEHiLzHXCE6RO_GdMlPleCjnOAdyBYsMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardpnRx_BTCkYG5ZRvOqknJOQpRIltI3vSOKR19uO6rrdcMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesGKbKww0VWkgYD_45x9BGpfXWzOqsbu44Y6cloowPM5afoMeta } from "/var/www/2025-05-06_07_36/pages/personal/promocodes.vue?macro=true";
import { default as benchor5mU9lfJNRkKb659kooEiDCoJeigIBpEVN2XYpb_OcMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/bench.vue?macro=true";
import { default as booksAeCvyLumJIYHjL7LwJTSiDvsOjSTi5EPmYSeWJ6ljKwMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/books.vue?macro=true";
import { default as cableJfrVF6t6kYeRf8s5dMLTLN7vZm4BqsruZA9p4lzK3r0Meta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/cable.vue?macro=true";
import { default as chairNfDUlTM5HJ0DfPmUPjgk_i5izjNp7FUqL6Py7I2RvH8Meta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsxaXG0QTWfd49YRzTJRSJDgbQP1TzPhf7FXZRai1fv1YMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/goods.vue?macro=true";
import { default as indexBqI9KGyqQgmSaBzYqW07oIGQEFVFTAga4Wg6OAMMofYMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/index.vue?macro=true";
import { default as metalQqML8Ss4gSyYfA_9xWXjdRfCKWXgnAZsXkcIW7ymyTQMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/metal.vue?macro=true";
import { default as piano3KuFQcVPpvdInM4i6DWhD48ejCea2BCEd1NfDk_45makYMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/piano.vue?macro=true";
import { default as pipes0NOsmRNT52R59PYlx6jK3sCibutaKCJvWCb1gsFdytkMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsBD6zMbz6G5gSknhwdRkpyGFJhu8k90F6FnPlNAs8GxUMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45box8nWcE5_ni3UR4vt5t81P_97W69q__FfXmrFou6NUiQoMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93bTDXhxq6FHaxbf8IEZJ__45mdcPGp90ATFD_68G_bGq10Meta } from "/var/www/2025-05-06_07_36/pages/personal/bonus/[tab].vue?macro=true";
import { default as printI_KdzPckXyKdzSJ3WIR0f7_457wJoR3JNN8oB33xmjEqwMeta } from "/var/www/2025-05-06_07_36/pages/personal/order/print.vue?macro=true";
import { default as dishesfRYlkU7IdCpH33EcK9xPXyZ1TGGc_45Y2qJScm94MlBHcMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/dishes.vue?macro=true";
import { default as engineLtPsI3lJqNsgizPEwnyQNnGIXaHf1gwwro7q21Vt694Meta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberPfT0pH_45_wbyY_keGyDjSidkAXURPAJZxUONFhJ6xpCMMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsjfwXkHDnXKt7v5kTHuJ4MJhXJAvsRzXnBBGjrBmNuewMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmXQCtQarF7tk_uq3fv8uyn_Ms8oANrigQb0ngzLaurfQMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingYUSfUKT9e8BR4GOWvXHnpIyA7AcVPrvmsDWh_45_45WVotgMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalwpcyYGriP_45PilAOg_45g96lKVuCEw9TaVCDL_45NtYM5Fp0Meta } from "/var/www/2025-05-06_07_36/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93EEbgd5KbpTrCTdR4j_jvQzQHi16uKBfUbA_45Xc_45G8zIoMeta } from "/var/www/2025-05-06_07_36/pages/personal/order/[guid].vue?macro=true";
import { default as createySL0dBVgHynerR7clq88wuufN17tEU_5zIbMMCy2JfcMeta } from "/var/www/2025-05-06_07_36/pages/personal/order/create.vue?macro=true";
import { default as barrelsTWh9M4clR3pBgRmlE7cQ_45tcTut3oHiHQcukTlr7t6NMMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothes6HPQtFI4mlvx46LKx5bGJeafYkuXtMWUyBfD3s_45blQkMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragiletP05YNbnV_45xvri7Yg_45EwK6wCh_456V3ilKsNS5CqiYNXIMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailer5shPEt10hrM3xeY4wHprMcFHZB5UU3x2VEPLRtyw9rwMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagehRdofFWCHBjNlaB9yz0OXdi1E96TyUMXrA_RQtzhYlkMeta } from "/var/www/2025-05-06_07_36/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successiYkLDAM5fJpZwQTW_45xpYspGWLaFRJnKGAka7tvEcnd8Meta } from "/var/www/2025-05-06_07_36/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagej9PMiZEgNCCESwhn14qtcDexoOQBwFHVdZ_6_KyYzn8Meta } from "/var/www/2025-05-06_07_36/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberries3YCveenEvbnUXPYFZMOWd_8psaCvVb1u8jLVMGt7uQcMeta } from "/var/www/2025-05-06_07_36/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_934w3TsyxIfp0FnYjnkkkKbqy0yKHpvEsobQnDPhOXpckMeta } from "/var/www/2025-05-06_07_36/pages/order/administer/[guid].vue?macro=true";
import { default as furniturezjNStsnlrep4zXSXKIhjAWz4n8aXgll0sdBoeGVgAYQMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversized3FPmxC91Lb77PQCjLgvLjYO83LAQ29_HOHFWOfRjXaAMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeycotnZHaPJAcMX6CVtIXT5SemW82gX4rCio9s1lRb1AMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93JK_3ebvK_tQ158PFVUVgQInTqNVGMAiu5aHNYN_45XJBUMeta } from "/var/www/2025-05-06_07_36/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93qZ7GZLarQU6EpBqRN_450FmU_VKxJgLK2jasg__tBdeNUMeta } from "/var/www/2025-05-06_07_36/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45parts_Y_45QAo_Go7o93GOtsDWngWP2qnHzQroAs3ZLMJLXyycMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersMs17f_3TiLUpgOaaBpQ0sybE78QGFhnTMMcvA1KeD5sMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargofzAgg7UVVrJ9TSgaXKyehMDugorFxgVHaAMIIHQQpCcMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileRVrIBmu_45pq_e1tjqTcnn87dACKQAnOix7_VlvmhA_45Z0Meta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexC_45EeueJ8wyBz_45aKgRghjSw11K1gIztwcln1UmzoNLzAMeta } from "/var/www/2025-05-06_07_36/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketk6sAMPLUcbyc70ZxURttumrHdq6DK7Inkutv2x3fA_45AMeta } from "/var/www/2025-05-06_07_36/pages/marketplace/yandex-market.vue?macro=true";
import { default as templateswjRhNJ4Nr_4540mu9cphoFJyZamkNNrvTmyNvHSBzZw8AMeta } from "/var/www/2025-05-06_07_36/pages/personal/orders/templates.vue?macro=true";
import { default as indexE9dXdiWYOjJ2nC8ZqZBeGXEmRM3SLZdE1c5WM3Pq_YEMeta } from "/var/www/2025-05-06_07_36/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorj8U4cqTRSd2YkmonbsEhj9jhaUGUR411ANFjGpaU6LoMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93OVuBMp8ySE_45Hpliz3cDZ19YQOP5BQehyPM_45NTXj8OqUMeta } from "/var/www/2025-05-06_07_36/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexPMAFlXFws56E1kDPZ0PpNUqRDIAQBfS_rupvrnSJ04MMeta } from "/var/www/2025-05-06_07_36/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93QA_45qs7ZC1mpxfGLA4GYkTCmLXjSSr5qBVWq81hlqXNwMeta } from "/var/www/2025-05-06_07_36/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodszMWOy6sEjTM_kFWTaIjV60cNCisZE0PeKO1R838cXXAMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexl8USHu6TK_TVXdzVmbag3lyKlk3NkHdOU_LU0NcdxZYMeta } from "/var/www/2025-05-06_07_36/pages/personal/group-printing/index.vue?macro=true";
import { default as index44YD7nngiSCIk_45cSOVJgwMNXna9757wopjU8sI_9n4UMeta } from "/var/www/2025-05-06_07_36/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesUojDRv13M49W3lH4Q_45ueYfcHMv2pbrVOs2D06nbSy6UMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93tHT8FZvc5mT4Vn_WgwPWJFglsB_45K1BHfXd7f7mNOftMMeta } from "/var/www/2025-05-06_07_36/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93_453B34BkzgtSX109yGu_O1x8ziF_45noZBujezSuvVa9V0Meta } from "/var/www/2025-05-06_07_36/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_931Bz5ioVIC1qyUrW6zC4jQ5qOyxcCjJq1r10Qj7eUMEMMeta } from "/var/www/2025-05-06_07_36/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentXWuLnzL_dpz81tUY_45B0izCyh8SDjeAYM9J0_45YMDpk2QMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materials4pBBpkf5LvjlACPjN87DfQBOKUuwmZ4vVnOOneYrPVMMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instruments_SM_45yoKa5L_YYfBWbdZbJj9Tt_45dsmzlftK4ShdG198YMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentW35Zs8W5C1wmcq5Ysbix_45_45hztK24ziypb0kVr21RXbsMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationOCujDmkKXVgBPNeii1BUd6ceDUXRHeQ_AN7NW5qgo0gMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93ITLSHQIpx3RjbeLX7_45Mngsqc2Z9KbSNEN_45lT0E9Ky7wMeta } from "/var/www/2025-05-06_07_36/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationBwfGzp9c8quPXKJqwPnEOuKK1d7_45v1hJFwKfOL5NzLEMeta } from "/var/www/2025-05-06_07_36/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-05-06_07_36/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-05-06_07_36/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-05-06_07_36/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-05-06_07_36/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-05-06_07_36/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93jWD_45tS4_SJZPazzqth3Z7dMNyLZ__45AR9uwcvjkHfkugMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-05-06_07_36/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-05-06_07_36/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-05-06_07_36/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-05-06_07_36/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursBHKUjnq_WB8ACnMe7UHPbq7ibBApHqr53a_vmU53FF8Meta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-05-06_07_36/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-05-06_07_36/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-05-06_07_36/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsrjGe0E6sjCxYr5_45ePlx2vRoYWKEvm_bVGcLVx_45AGGAAMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-05-06_07_36/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-05-06_07_36/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-05-06_07_36/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-05-06_07_36/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-05-06_07_36/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-05-06_07_36/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-05-06_07_36/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-05-06_07_36/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapScheme1FCvRJcdpPl1Hp7kWuyGcGlSTLcOSOAEO2hZF5S5TcwMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93BNFh2j8i9LH3gnKm6us783A09JCt6jKNx6clB65vB2QMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-05-06_07_36/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-05-06_07_36/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-05-06_07_36/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-05-06_07_36/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-05-06_07_36/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-05-06_07_36/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexYu3Dqwy7AFsNod7DiWwzh5HMuNX110Kw28JkMTjBo2oMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-05-06_07_36/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-05-06_07_36/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorZMJtkxXqWlR9_NyKtiXTeLYLDJxUtWLVk0zAbkqgM6YMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexvVLVgW_aW8I_upHgOPvo0n4Qz2bFBIirebHjKr5UA54Meta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-05-06_07_36/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-05-06_07_36/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93aOIikxDtXepULXBhQhDgs2rjgvFSEKvEb0T5BVnIlmQMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-05-06_07_36/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-05-06_07_36/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-05-06_07_36/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-05-06_07_36/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-05-06_07_36/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-05-06_07_36/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-05-06_07_36/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-05-06_07_36/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-05-06_07_36/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthday3supBCJBOfxfdVRn4gdUYnRsyBxXWdJjwUaNHCt3DpYMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageaz6D9blJhAbAd0A4O6rPkjeI9soWZsy4MBitqItMiHcMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-05-06_07_36/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-05-06_07_36/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsu6mgveuUc_A2N_45gn7YypnfZTxLUS2WZ2c4Ir_45_45prMzUMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: index3wLWBKwFRdCKGCcoKf4PS7I_45Rak7XW_45TsUkKAKWRK_45YMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-05-06_07_36/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-05-06_07_36/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-05-06_07_36/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-05-06_07_36/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-05-06_07_36/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-05-06_07_36/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importSNpKJKWe7322wArEKRqXwYNlU_45uGoZrEKPcUSQUCHwUMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutIsPT4Zt5nTkvRNTCzZjCH0KTS97IqNm23KD9x7dG5GsMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-05-06_07_36/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-05-06_07_36/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024cN5KLKUff4izFHDj4no3rWlcQlCNGeRYPOZOvwquVl8Meta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozoncn7_YnSuN_457LPMWndbwxEhxKu6vuIevfst3jqBwqZWEMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-05-06_07_36/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountg2sIuyb7HF8bEUmUQOBhPfgsNtsbmrH_Y_6wq_DUN6kMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-05-06_07_36/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-05-06_07_36/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-05-06_07_36/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-05-06_07_36/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorbpjHxjmLcSE4RInMBhTd_46Q4nvWvPPoI67qmUkf3gcMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-05-06_07_36/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-05-06_07_36/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountAW8pg_SDINfRU_45SfyOBUrx8jLFJ5lZDL2scvvdxS9MoMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-05-06_07_36/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917yj1wManieOVTEHqe5XgAlSx8TIBC0VP_RxdfVymf5bQMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-05-06_07_36/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexiIyzLNCSjRMczh_45sN7PgdVMrZ209nh_fyysTsyHAIvMMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesGKbKww0VWkgYD_45x9BGpfXWzOqsbu44Y6cloowPM5afoMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93bTDXhxq6FHaxbf8IEZJ__45mdcPGp90ATFD_68G_bGq10Meta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printI_KdzPckXyKdzSJ3WIR0f7_457wJoR3JNN8oB33xmjEqwMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-05-06_07_36/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93EEbgd5KbpTrCTdR4j_jvQzQHi16uKBfUbA_45Xc_45G8zIoMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createySL0dBVgHynerR7clq88wuufN17tEU_5zIbMMCy2JfcMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-05-06_07_36/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-05-06_07_36/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberries3YCveenEvbnUXPYFZMOWd_8psaCvVb1u8jLVMGt7uQcMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93qZ7GZLarQU6EpBqRN_450FmU_VKxJgLK2jasg__tBdeNUMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexC_45EeueJ8wyBz_45aKgRghjSw11K1gIztwcln1UmzoNLzAMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketk6sAMPLUcbyc70ZxURttumrHdq6DK7Inkutv2x3fA_45AMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templateswjRhNJ4Nr_4540mu9cphoFJyZamkNNrvTmyNvHSBzZw8AMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexE9dXdiWYOjJ2nC8ZqZBeGXEmRM3SLZdE1c5WM3Pq_YEMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93OVuBMp8ySE_45Hpliz3cDZ19YQOP5BQehyPM_45NTXj8OqUMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexPMAFlXFws56E1kDPZ0PpNUqRDIAQBfS_rupvrnSJ04MMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93QA_45qs7ZC1mpxfGLA4GYkTCmLXjSSr5qBVWq81hlqXNwMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexl8USHu6TK_TVXdzVmbag3lyKlk3NkHdOU_LU0NcdxZYMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: index44YD7nngiSCIk_45cSOVJgwMNXna9757wopjU8sI_9n4UMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93tHT8FZvc5mT4Vn_WgwPWJFglsB_45K1BHfXd7f7mNOftMMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93_453B34BkzgtSX109yGu_O1x8ziF_45noZBujezSuvVa9V0Meta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_931Bz5ioVIC1qyUrW6zC4jQ5qOyxcCjJq1r10Qj7eUMEMMeta || {},
    component: () => import("/var/www/2025-05-06_07_36/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-05-06_07_36/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-05-06_07_36/pages/shippingtypes/personalitemstransportation.vue")
  }
]